<div class="app-headline-container font-medium truncate">
  <div *ngIf="routingObject?.backButton" class="user_back flex place-items-center">
    <div class="">
      <button class="!py-2" type="button" mat-raised-button (click)="navUrl([routingObject.backURL || ''])"><mat-icon>chevron_left</mat-icon>Back</button>
    </div>
    <p class="text-5xl px-6">{{ loggedInUser.name }}</p>
  </div>
  <ng-container *ngIf="!routingObject?.backButton" class="page_name">
    <h1 *ngIf="!hasBackLink; else backButtonTitle" class="app-headline">
      {{ headline || routingObject.text }}
    </h1>
    <ng-template #backButtonTitle>
      <div class="app-title-wrapper">
        <button class="back-button" mat-icon-button (click)="onBackClick()" aria-label="Go back">
          <mat-icon class="material-icons-outlined">arrow_back</mat-icon>
        </button>
        <h1 class="app-headline">
          {{ headline }}
        </h1>
      </div>
    </ng-template>
    <h2 class="text-base font-medium truncate" *ngIf="subHeadline?.id">
      {{ subHeadline?.id }}
      <span *ngIf="subHeadline?.name">
        &#160;&#160;&#160; • &#160;&#160;&#160;
        <span class="underline cursor-pointer inline-grid" [routerLink]="headerLink" matRipple>{{ subHeadline?.name }}</span>
      </span>
    </h2>
  </ng-container>
</div>
